import { Brand, Program } from '..';

const FewoDirektPrograms: Record<string, Program> = {
  'fewo-direkt': {
    id: 'fewo-direkt',
    name: 'FeWo-direkt DE',
    brand: Brand.FEWO_DIREKT,
    posa: 'DE',
    currency: 'EUR',
    locale: {
      baseName: 'de_DE',
      langId: 1031,
    },
  },
};

export { FewoDirektPrograms };
